(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-complementary"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return

    const section = entries[0].target
    observer.unobserve(section)

    const url = section.dataset.url

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')

        if (recommendations) {
          const hasContent = recommendations.innerHTML.trim().length > 0
          if (hasContent) {
            section.innerHTML = recommendations.innerHTML
            if (window.Alpine) {
              window.Alpine.initTree(section)
            }
          } else {
            const sectionContainer = section.closest('.section-product-complementary')
            if (sectionContainer) {
              sectionContainer.style.display = 'none'
            }
          }
        }
      })
      .catch((e) => {
        console.error('Error fetching recommendations:', e)
        const sectionContainer = section.closest('.section-product-complementary')
        if (sectionContainer) sectionContainer.style.display = 'none'
      })
  }

  const initRecommendations = () => {
    const productRecommendationsSections = document.querySelectorAll(
      '.product-recommendations:not([data-recommendations-observed])'
    )
    productRecommendationsSections.forEach((section) => {
      section.setAttribute('data-recommendations-observed', 'true')
      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '0px 0px 400px 0px',
      })
      observer.observe(section)
    })
  }

  initRecommendations()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return

    const section = entries[0].target
    observer.unobserve(section)

    const url = section.dataset.url

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')

        if (recommendations) {
          const hasContent = recommendations.innerHTML.trim().length > 0
          if (hasContent) {
            section.innerHTML = recommendations.innerHTML
            if (window.Alpine) {
              window.Alpine.initTree(section)
            }
          } else {
            const sectionContainer = section.closest('.section-product-recommendations')
            if (sectionContainer) {
              sectionContainer.style.display = 'none'
            }
          }
        }
      })
      .catch((e) => {
        console.error('Error fetching recommendations:', e)
        const sectionContainer = section.closest('.section-product-recommendations')
        if (sectionContainer) sectionContainer.style.display = 'none'
      })
  }

  const initRecommendations = () => {
    const productRecommendationsSections = document.querySelectorAll(
      '.product-recommendations:not([data-recommendations-observed])'
    )
    productRecommendationsSections.forEach((section) => {
      section.setAttribute('data-recommendations-observed', 'true')
      const observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '0px 0px 400px 0px',
      })
      observer.observe(section)
    })
  }

  initRecommendations()

  } catch(e) { console.error(e); }
})();
})();
